// const URL = `http://localhost:4040`
const URL = `https://crispy-octo.onrender.com`

export { URL }